import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const ProjectCarousel = ({ group }) => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = group.images || [];

  useEffect(() => {
    if (images.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 2500); // Change image every 2.5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  if (images.length === 0) {
    return (
      <Card className="overflow-hidden">
        <div className="h-64 bg-slate-200 flex items-center justify-center">
          <p className="text-slate-500">Aucune image</p>
        </div>
      </Card>
    );
  }

  return (
    <Card className="overflow-hidden group hover:shadow-2xl transition-all duration-300 border-2 border-slate-700">
      <div className="relative h-80 overflow-hidden">
        {images.map((image, idx) => (
          <img
            key={idx}
            src={image}
            alt={`Réalisation béton décoratif - ${idx + 1}`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
              idx === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
        {images.length > 1 && (
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-1.5">
            {images.map((_, idx) => (
              <div
                key={idx}
                className={`h-1.5 rounded-full transition-all ${
                  idx === currentIndex ? 'w-8 bg-white' : 'w-1.5 bg-white/50'
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </Card>
  );
};

export default ProjectCarousel;
